import { useNavigate, useParams } from "react-router-dom";
import { axiosInstance } from "../../../Services/Interceptor/Interceptor";
import API_END_POINTS from "../../../Utilities/Constants/ApiEndpoints";
import "./AddEditUniversity.scss";
import { ChangeEvent, useRef, useState, useEffect } from "react";
import {
  ADD_SCHOOLS,
  ADD_UNIVERSITY_FIELDS,
  API_RESPONSE,
  COMMON_CONSTANTS,
  I18_TRANSLATION_COMMON,
  ROUTES,
  TOASTER_CONFIGS,
  TOAST_ERRORS,
} from "../../../Utilities/Constants/Constants";
import * as yup from "yup";
import {
  ADD_SCHOOLS_ERROR_MESSAGES,
  EDIT_UNIVERSITY_ERROR_MESSAGE,
  ERROR_MESSAGES,
  REGEX,
} from "../../../Utilities/Constants/Validations";
import { Field, Formik } from "formik";
import { useTranslation } from "react-i18next";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { DesktopDatePicker } from "@mui/x-date-pickers/DesktopDatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import {
  S3DataGetApi,
  nullUndefinedEmptyCheck,
  numberOnlyWithDecimal,
} from "../../../Services/Helpers/Helper";
import AddOutlinedIcon from "@mui/icons-material/AddOutlined";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { toast } from "react-toastify";
import CancelIcon from "@mui/icons-material/Cancel";
import backButton from "../../../../Assets/schools/back_button.svg";
import eyeIcon from "../../../../Assets/schools/eye.svg";
import uploadFile from "../../../../Assets/schools/upload.svg";
import upload_image from "../../../../Assets/schools/upload_image.svg";
import close from "../../../../Assets/schools/close.svg";
import PhoneInput from "react-phone-input-2";
import { isValidPhoneNumber } from "libphonenumber-js";
import ar from "react-phone-input-2/lang/ar.json";
import { useSelector } from "react-redux";
import {
  List,
  ListItemButton,
  ListItemText,
  MenuItem,
  Select,
  TextField,
} from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import FileUploadIcon from "@mui/icons-material/FileUpload";
import { GoogleMap, Marker, MarkerF, useLoadScript, useJsApiLoader, Autocomplete } from "@react-google-maps/api";
import RoomIcon from '@mui/icons-material/Room';
import LocationOffIcon from '@mui/icons-material/LocationOff';
import VisibilityIcon from '@mui/icons-material/Visibility';
import FileViewerDialog from "../../../Shared/FileViewerDialog/FileViewerDialog";
import { format } from "date-fns";
import { store } from "../../../Services/Redux/Store/Store";
import { setLoader } from "../../../Services/Redux/Reducer/Reducer";
import { Autocomplete as MuiAutocomplete } from '@mui/material';

const libraries: any = ['places'];

const AddEditUniversity = () => {
  const { isLoaded }: any = useJsApiLoader({
    googleMapsApiKey: process.env.REACT_APP_GOOGLE_API_KEY || '',
    libraries
  });
  const geocoder: any = isLoaded ? new window.google.maps.Geocoder() : '';
  const formikRef = useRef<any>();
  const { id } = useParams();
  const [currentLocation, setCurrentLocation]: any = useState();
  const [mapEnabled, setMapEnabled] = useState(API_RESPONSE.TRUE);
  const ratingTerms = [
    "Excellent",
    "Outstanding",
    "Good",
    "Acceptable",
    "Unsatisfactory"
  ]

  interface UnivercitysData {
    [key: string]: any;
  }
  const [universityDetail, setUniversityDetail] = useState<UnivercitysData>({
    [ADD_UNIVERSITY_FIELDS.UNIVERSITY_NAME]: "",
    [ADD_UNIVERSITY_FIELDS.UNIVERSITY_NAME_ARABIC]: "",
    [ADD_UNIVERSITY_FIELDS.LOCATION]: "",
    [ADD_UNIVERSITY_FIELDS.UNIVERSITY_IMAGES]: "",
    [ADD_UNIVERSITY_FIELDS.WEBSITE_ADDRESS]: "",
    [ADD_UNIVERSITY_FIELDS.EMAIL]: "",
    [ADD_UNIVERSITY_FIELDS.PHONE_NUMBER]: "",
    [ADD_UNIVERSITY_FIELDS.NO_OF_STUDENTS]: id ? "N/A" : null,
    [ADD_UNIVERSITY_FIELDS.RATING]: id ? "N/A" : 0,
    [ADD_UNIVERSITY_FIELDS.EMIRATES]: "",
    [ADD_UNIVERSITY_FIELDS.CITY]: "",
    [ADD_UNIVERSITY_FIELDS.GLOBAL_RANKING]: id ? "N/A" : null,
    [ADD_UNIVERSITY_FIELDS.SHANGAI_RANKING]: id ? "N/A" : null,
    [ADD_UNIVERSITY_FIELDS.AVAILABLE_MEDIUM]: "",
    [ADD_UNIVERSITY_FIELDS.TOTAL_COURSES]: id ? "N/A" : null,
    [ADD_UNIVERSITY_FIELDS.PRINCIPAL]: id ? "N/A" : null,
    [ADD_UNIVERSITY_FIELDS.DESCRIPTION]: "",
    [ADD_SCHOOLS.FOUNDED_YEAR]: id ? "N/A" : null,
    [ADD_UNIVERSITY_FIELDS.QS_RANKING]: id ? "N/A" : null,
    [ADD_UNIVERSITY_FIELDS.THE_RANKING]: id ? "N/A" : null,
    [ADD_UNIVERSITY_FIELDS.SH_RANKING]: id ? "N/A" : null,

  });
  const inputRef = useRef<any>(null);
  const [appProcessPoints, setAppProcessPoints]: any = useState("");
  const [applicationProcess, setApplicationProcess] = useState<any>([]);
  const [eligibilityPoints, setEligibilityPoints]: any = useState("");
  const [eligibilityCriteria, setEligibilityCriteria] = useState<any>([]);
  const [formSubmitted, setFormSubmitted] = useState(false);
  const [classificationType, setClassificationType] = useState(" ");
  const [courseName, setCourseName] = useState(" ");
  const [courseFee, setCourseFee] = useState("");
  const [programType, setProgramType] = useState(" ")
  const [programsOffered, setProgrammsOffered] = useState<any>([]);
  const [imageBanner, setImageBanner] = useState<any>(null);
  const bannerImage = useRef<HTMLInputElement | null>(null);
  const [fileViewerOpen, setFileViewerOpen] = useState(false);
  const [viewerFile, setViewerFile] = useState("");
  const [subProgramName, setSubprogramName] = useState("");
  const [programName, setProgramName] = useState("");
  const [programOffered, setProgramOffered] = useState("");
  const currentYear = new Date().getFullYear();
  const [EmiratesList, setEmiratesList]: any = useState<any>([]);
  const [autocomplete, setAutocomplete] = useState<any>(null);

  const aws: any = useSelector((state: any) => {
    return state.awsReducer.aws;
  });
  const shouldDisableYear = (year: any) => {
    return new Date(year).getFullYear() > currentYear;
  };

  useEffect(() => {
  const pathName = window.location?.pathname;
  const payload = {
    record_area: pathName.slice(1)
  }
  axiosInstance.post(`${API_END_POINTS?.RECORD_AREA}`, payload).then((response: any) => {
  }).catch(() => {
  })
}, [])
  useEffect(() => {
    getUniversityFields();
    if (id)
      getUniversityDetail();

    getEmiratesList();
  }, []);

  useEffect(() => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          const { latitude, longitude } = position.coords;
          setCurrentLocation({ lat: latitude, lng: longitude });
        },
      );
    }
  }, [])

  const [universityImages, setUniversityImages]: any = useState([]);

  const [degreeType, setDegreeType] = useState([]);
  const [fieldType, setFieldType] = useState([]);
  const [specification, setSpecification] = useState<any>([]);
  const navigate = useNavigate();

  const getUniversityFields = () => {
    axiosInstance
      .get(API_END_POINTS.DEGREE_TYPE)
      .then((response) => {
        setDegreeType(response.data.result.data);
      });

    axiosInstance
      .get(API_END_POINTS.FIELD_OF_STUDY)
      .then((response) => {
        setFieldType(response.data.result.data);
      });

    axiosInstance
      .get(API_END_POINTS.SPECIFICATION)
      .then((response) => {
        setSpecification(response.data.result.data);
      });
  };

  const getUniversityDetail = () => {
    axiosInstance
      .get(API_END_POINTS.UNIVERSITY_API + "?id=" + id)
      .then((res) => {
        setUniversityValues(res.data.result.data);
        setUniversityImages(res.data.result.data.images);
      });
  };

  const getEmiratesList = () => {
    axiosInstance.get(API_END_POINTS.EMIRATE_LIST).then((response) => {
      setEmiratesList(response?.data?.result?.data)
    }).catch(() => { })
  }


  const setUniversityValues = (data: any) => {
    setUniversityDetail({
      [ADD_UNIVERSITY_FIELDS.UNIVERSITY_NAME]: data.university_name,
      [ADD_UNIVERSITY_FIELDS.UNIVERSITY_NAME_ARABIC]: data.arabic_university_name ? data.arabic_university_name : "اسم sample عربي",
      [ADD_UNIVERSITY_FIELDS.LOCATION]: data.address,
      [ADD_UNIVERSITY_FIELDS.WEBSITE_ADDRESS]: data.web_link,
      [ADD_UNIVERSITY_FIELDS.PRINCIPAL]: data.principal,

      [ADD_UNIVERSITY_FIELDS.EMAIL]: data.email,
      [ADD_UNIVERSITY_FIELDS.PHONE_NUMBER]: data?.phone_number
        ? data?.phone_number
        : "",
      [ADD_UNIVERSITY_FIELDS.PROGRAMS_OFFERED]: data.programs_offered
        ? data.programs_offered
        : "",
      [ADD_UNIVERSITY_FIELDS.RESEARCH]: data.research ? data.research : "",
      [ADD_UNIVERSITY_FIELDS.RATING]: data.rating ? data.rating === "" ? 0 : data.rating : 0,
      [ADD_UNIVERSITY_FIELDS.OVERALL_RATING]: data.overall_rating
        ? data.overall_rating
        : "",
      [ADD_UNIVERSITY_FIELDS.NO_OF_STUDENTS]: data.students_count != ""
        ? data.students_count
        : "N/A",
      [ADD_UNIVERSITY_FIELDS.EMIRATES]: data.emirate
        ? data.emirate
        : "",
      [ADD_UNIVERSITY_FIELDS.CITY]: data.city
        ? data.city
        : "",
      [ADD_UNIVERSITY_FIELDS.COUNTRY]: data?.country,
      [ADD_UNIVERSITY_FIELDS.GLOBAL_RANKING]: data.global_ranking,
      [ADD_UNIVERSITY_FIELDS.SHANGAI_RANKING]: data.shangai_ranking,
      [ADD_UNIVERSITY_FIELDS.AVAILABLE_MEDIUM]: data.available_mediums,
      [ADD_UNIVERSITY_FIELDS.TOTAL_COURSES]: data.courses ? data.courses : null,
      [ADD_UNIVERSITY_FIELDS.DESCRIPTION]: data.description,
      [ADD_SCHOOLS.FOUNDED_YEAR]: data.founded_year ? data.founded_year : "",
      [ADD_UNIVERSITY_FIELDS.QS_RANKING]: data.QS_ranking ? data.QS_ranking : null,
      [ADD_UNIVERSITY_FIELDS.SH_RANKING]: data.SH_ranking ? data.SH_ranking : null,
      [ADD_UNIVERSITY_FIELDS.THE_RANKING]: data.THE_ranking ? data.THE_ranking : null,
    });
    setImageBanner(data.academic_calendar);
    setApplicationProcess(data.application_process);
    setEligibilityCriteria(data.eligibility_criteria);
    setProgrammsOffered(data.program_offered);
    if (data.latitude)
      setCurrentLocation({ lat: parseFloat(data.latitude), lng: parseFloat(data.longitude) })
  };
  const addEditUniversityDetail = (payload: any) => {
    payload.images = universityImages;
    payload.program_offered = programsOffered;
    payload.eligibility_criteria = eligibilityCriteria;
    payload.application_process = applicationProcess;
    payload.academic_calendar = imageBanner;
    payload.latitude = currentLocation.lat;
    payload.longitude = currentLocation.lng;
    payload[ADD_UNIVERSITY_FIELDS.CITY] = payload[ADD_UNIVERSITY_FIELDS.COUNTRY] === 'United Arab Emirates' ? payload[ADD_UNIVERSITY_FIELDS.CITY] : "";
    payload[ADD_UNIVERSITY_FIELDS.EMIRATES] = payload[ADD_UNIVERSITY_FIELDS.COUNTRY] === 'United Arab Emirates' ? payload[ADD_UNIVERSITY_FIELDS.EMIRATES] : "";
    payload[ADD_UNIVERSITY_FIELDS.NO_OF_STUDENTS] = (payload[ADD_UNIVERSITY_FIELDS.NO_OF_STUDENTS] === "N/A") || (payload[ADD_UNIVERSITY_FIELDS.NO_OF_STUDENTS] === "") ? null : payload[ADD_UNIVERSITY_FIELDS.NO_OF_STUDENTS];
    payload[ADD_UNIVERSITY_FIELDS.RATING] = (payload[ADD_UNIVERSITY_FIELDS.RATING] === "N/A") || (payload[ADD_UNIVERSITY_FIELDS.RATING] === "") ? 0 : payload[ADD_UNIVERSITY_FIELDS.RATING];
    payload[ADD_UNIVERSITY_FIELDS.GLOBAL_RANKING] = (payload[ADD_UNIVERSITY_FIELDS.GLOBAL_RANKING] === "N/A") || (payload[ADD_UNIVERSITY_FIELDS.GLOBAL_RANKING] === "") ? null : payload[ADD_UNIVERSITY_FIELDS.GLOBAL_RANKING];
    payload[ADD_UNIVERSITY_FIELDS.SHANGAI_RANKING] = (payload[ADD_UNIVERSITY_FIELDS.SHANGAI_RANKING] === "N/A") || (payload[ADD_UNIVERSITY_FIELDS.SHANGAI_RANKING] === "") ? null : payload[ADD_UNIVERSITY_FIELDS.SHANGAI_RANKING];
    payload[ADD_UNIVERSITY_FIELDS.TOTAL_COURSES] = (payload[ADD_UNIVERSITY_FIELDS.TOTAL_COURSES] === "N/A") || (payload[ADD_UNIVERSITY_FIELDS.TOTAL_COURSES] === "") ? null : payload[ADD_UNIVERSITY_FIELDS.TOTAL_COURSES];
    payload[ADD_UNIVERSITY_FIELDS.PRINCIPAL] = (payload[ADD_UNIVERSITY_FIELDS.PRINCIPAL] === "N/A") || (payload[ADD_UNIVERSITY_FIELDS.PRINCIPAL] === "") ? null : payload[ADD_UNIVERSITY_FIELDS.PRINCIPAL];
    payload[ADD_UNIVERSITY_FIELDS.THE_RANKING] = (payload[ADD_UNIVERSITY_FIELDS.THE_RANKING] === "N/A") || (payload[ADD_UNIVERSITY_FIELDS.THE_RANKING] === "") ? null : payload[ADD_UNIVERSITY_FIELDS.THE_RANKING];
    payload[ADD_UNIVERSITY_FIELDS.QS_RANKING] = (payload[ADD_UNIVERSITY_FIELDS.QS_RANKING] === "N/A") || (payload[ADD_UNIVERSITY_FIELDS.QS_RANKING] === "") ? null : payload[ADD_UNIVERSITY_FIELDS.QS_RANKING];
    payload[ADD_UNIVERSITY_FIELDS.SH_RANKING] = (payload[ADD_UNIVERSITY_FIELDS.SH_RANKING] === "N/A") || (payload[ADD_UNIVERSITY_FIELDS.SH_RANKING] === "") ? null : payload[ADD_UNIVERSITY_FIELDS.SH_RANKING];
    payload.courses = nullUndefinedEmptyCheck(payload.courses) ? payload.courses : null;
    payload.rating = payload.rating === "" ? 0 : payload.rating;
    if (id) {
      axiosInstance
        .put(API_END_POINTS.ADD_UNIVERSITY + "?id=" + id, payload)
        .then((res) => {
          if (res.data.status === true) {
            toast.success(res.data.message, TOASTER_CONFIGS);
            navigate(ROUTES.MANAGE_UNIVERSITIES);
          }
        }).catch((error) => { console.error(error) });
    } else {
      axiosInstance.post(API_END_POINTS.ADD_UNIVERSITY, payload).then((res) => {
        if (res.data.status === true) {
          toast.success(res.data.message, TOASTER_CONFIGS);
          navigate(ROUTES.MANAGE_UNIVERSITIES);
        }
      }).catch((error) => { console.error(error) });
    }

  };
  const [validNumber, setValidNumber] = useState(true);
  const { t, i18n } = useTranslation(I18_TRANSLATION_COMMON.COMMON);
  const language: any = useSelector((state: any) => {
    return state.languageReducer.language;
  });
  const universityValidationSchema = yup.object({
    [ADD_UNIVERSITY_FIELDS.UNIVERSITY_NAME]: yup
      .string()
      .required(EDIT_UNIVERSITY_ERROR_MESSAGE.UNIVERSITY_NAME),

    [ADD_UNIVERSITY_FIELDS.UNIVERSITY_NAME_ARABIC]: yup
      .string()
      .required(EDIT_UNIVERSITY_ERROR_MESSAGE.UNIVERSITY_NAME_ARABIC),
    
    [ADD_UNIVERSITY_FIELDS.LOCATION]: yup
      .string()
      .required(EDIT_UNIVERSITY_ERROR_MESSAGE.LOCATION_REQUIRED),
    [ADD_UNIVERSITY_FIELDS.UNIVERSITY_IMAGES]: yup
      .array()
      .typeError("")
      .min(1, EDIT_UNIVERSITY_ERROR_MESSAGE.UNIVERSITY_IMAGES),
    [ADD_UNIVERSITY_FIELDS.WEBSITE_ADDRESS]: yup
      .string()
      .matches(REGEX.URL_VALIDATION, EDIT_UNIVERSITY_ERROR_MESSAGE.VALID_URL)
      .required(EDIT_UNIVERSITY_ERROR_MESSAGE.WEBSITE_ADDRESS),

    [ADD_UNIVERSITY_FIELDS.EMAIL]: yup
      .string()
      .matches(REGEX.EMAIL, ERROR_MESSAGES.INVALID_EMAIL)
      .required(EDIT_UNIVERSITY_ERROR_MESSAGE.EMAIL_REQUIRED),
    [ADD_UNIVERSITY_FIELDS.PHONE_NUMBER]: yup
      .string()
      .required(ERROR_MESSAGES.PHONE_NUMBER),
    [ADD_UNIVERSITY_FIELDS.DEGREES_AND_FEES]: yup.string(),

    [ADD_UNIVERSITY_FIELDS.DESCRIPTION]: yup
      .string()
      .required(EDIT_UNIVERSITY_ERROR_MESSAGE.DESCRIPTION_REQUIRED),
    [ADD_UNIVERSITY_FIELDS.EMIRATES]: yup
      .string(),
    [ADD_UNIVERSITY_FIELDS.CITY]: yup
      .string(),
    [ADD_UNIVERSITY_FIELDS.COUNTRY]: yup
      .string()
      .required(ADD_SCHOOLS_ERROR_MESSAGES.COUNTRY),
    
    [ADD_UNIVERSITY_FIELDS.AVAILABLE_MEDIUM]: yup
      .string()
      .required(EDIT_UNIVERSITY_ERROR_MESSAGE.AVAILABLE_MEDIUM),
   
  });

  const uploadUniversityImages = useRef<HTMLInputElement | null>(null);

  const ratingRestriction = (event: any) => {
    const enteredValue = event.target.value + event.data;
    const parsedValue = parseFloat(enteredValue);

    if (parsedValue > 5) {
      event.preventDefault();
    } else {
      numberOnlyWithDecimal(event);
    }
  };
  useEffect(() => {
    formikRef.current.setFieldValue(
      ADD_UNIVERSITY_FIELDS.UNIVERSITY_IMAGES,
      universityImages
    );
  }, [universityImages]);
  const handleChange = async (event: any) => {
    const files = event.target.files;
    let typeValidation: any = Array.from(files).map((file: any) => {
      return file.type.split('/')[0] === "image"
    });
    try {
      if (universityImages.length + event.target.files.length <= 10 && !typeValidation.includes(false) && event.target.files.length !== 0) {
        for (let i = 0; i < event.target.files.length; i++) {
          store.dispatch(setLoader(true));
          const uploadedImage = await S3DataGetApi(event);
          setTimeout(() => {
            setUniversityImages((schoolImages: any) => [
              ...schoolImages,
              uploadedImage,
            ]);
            store.dispatch(setLoader(false));
          }, 0);
        }
      } else {
        if (event.target.files.length !== 0)
          universityImages.length + event.target.files.length >= 10 ? toast.error(TOAST_ERRORS.IMAGES_LIMIT) : toast.error("Please upload only images");
      }
    } catch (error) {
      toast.error(`${TOAST_ERRORS.IMAGE_UPLOAD_ERROR}` + `${error}`);
    }

  };

  const onUploadEventImage = async (event: any, eventName: string) => {
    try {
      if (event.target.files[0].type.split("/")[1] === "pdf") {
        store.dispatch(setLoader(true));
        const uploadedImage = await S3DataGetApi(event);
        setImageBanner(uploadedImage);
        store.dispatch(setLoader(false));
      } else {
      }
    } catch (error) { }
  };

  const onAddProgram = () => {
    let data = programsOffered;
    if (nullUndefinedEmptyCheck(programType) && nullUndefinedEmptyCheck(classificationType) && nullUndefinedEmptyCheck(courseName) && nullUndefinedEmptyCheck(courseFee)) {
      data.push({
        id: 0,
        program_id: programType,
        program_class_name: programName,
        university_program_name: programOffered,
        program_classification_id: classificationType,
        sub_program_class_name: subProgramName,
        sub_program_name_id: courseName,
        price: courseFee,
      });
      setProgrammsOffered([...data]);
      setClassificationType(" ");
      setCourseName(" ");
      setCourseFee("");
      setProgramType(" ");
      setProgramName("");
      setSubprogramName("");
    }

  };

  const handleDelete = (i: any) => () => {
    setUniversityImages(
      universityImages.filter((item: any, index: any) => index !== i)
    );
  };

  const setCurrentLatLng = (latitude: any, longitude: any) => {
    setCurrentLocation({ lat: latitude, lng: longitude });
  }

  const getFormattedAddress = (lat: any, lng: any, formik: any, check: boolean) => {
    geocoder.geocode({ location: { lat, lng } }, (results: any, status: any) => {
      if (status === "OK") {
        if (results[COMMON_CONSTANTS.ZERO]) {
          let filterCountry = results[COMMON_CONSTANTS.ZERO]?.address_components?.filter((res: any) => {
            return res.types[0] === 'country'
          });

          if (results[COMMON_CONSTANTS.ZERO]) {
            if (check) {
              formik.setFieldValue(
                ADD_UNIVERSITY_FIELDS.LOCATION,
                results[COMMON_CONSTANTS.ZERO].formatted_address
              )
            }
            formik.setFieldValue(
              ADD_UNIVERSITY_FIELDS.COUNTRY,
              filterCountry[0]?.long_name ? filterCountry[0]?.long_name : "N/A"
            )
          }
        }
      }
    });
  }


  const onFilerViewerDialogOpen = (url: any) => {
    setViewerFile(url);
    setFileViewerOpen(true);
  };

  const onFilerViewerDialogClose = () => {
    setFileViewerOpen(false);
    setViewerFile("");
  };

  function numberOnly(event: any) {
    const input = event.target;
    const value = input.value;

    const sanitizedValue = value.replace(
      /[^\d.]/g,
      (match: any, offset: any) => {
        if (match === "." && offset === 0) {
          return match;
        }
        return "";
      }
    );

    const decimalIndex = sanitizedValue.indexOf(".");
    if (decimalIndex !== -1 && sanitizedValue.length - decimalIndex > 2 + 1) {
      input.value = sanitizedValue.slice(0, decimalIndex + 3);
    } else {
      input.value = sanitizedValue;
    }
  }

  const onPlaceChanged = (formik: any) => {
    if (autocomplete !== null) {
      const place = autocomplete.getPlace();
      if (place?.geometry) {
        const location = place?.geometry?.location;
        const lat = location.lat();
        const lng = location.lng();

        setCurrentLatLng(lat, lng);
        getFormattedAddress(lat, lng, formik, false);
        if (inputRef?.current) {
          const inputValue = inputRef.current.value;
          formik.setFieldValue(ADD_UNIVERSITY_FIELDS.LOCATION, inputValue);
        }
      }
    }
  };

  const onAutocompleteLoad = (autoC: any) => {
    setAutocomplete(autoC); 
  };

  return (
    <>
      <FileViewerDialog
        open={fileViewerOpen}
        handleClose={onFilerViewerDialogClose}
        viewerFile={viewerFile}
      ></FileViewerDialog>
      <Formik
        innerRef={formikRef}
        initialValues={universityDetail}
        validationSchema={universityValidationSchema}
        onSubmit={(values, actions) => {
          addEditUniversityDetail(values);
        }}
        enableReinitialize={true}
      >
        {(formik) => (
          <div className="school_fields_container">
            <div className="arrow-wrap">
              <img
                className="school-back"
                onClick={() => {
                  navigate(ROUTES.MANAGE_UNIVERSITIES);
                }}
                src={backButton}
                alt="Learn and Play"
              />
              <h5 className="name-title">
                {id ? t("Edit University") : t("Add University")}
              </h5>
            </div>
            <div className="row school-row-wrap">
              <div id="card-title">{t("Basic Details")}</div>
              {/* ************************Form Content Right*********************** */}
              <div className="col-md-6">
                <div id="card-wrap">
                  <div className="fields_label_wrapper">
                    <label className="fields_label mandatory_fields">
                      {t("University Name")}
                    </label>
                    <Field
                      className="form_inputs"
                      placeholder={t("University Name")}
                      name={ADD_UNIVERSITY_FIELDS.UNIVERSITY_NAME}
                    />
                    <div className="error-message-wrap">
                      {formik.touched[ADD_UNIVERSITY_FIELDS.UNIVERSITY_NAME] &&
                        formik.errors[ADD_UNIVERSITY_FIELDS.UNIVERSITY_NAME] ? (
                        <div className="errorMessage">
                          {t(
                            `${formik.errors[
                            ADD_UNIVERSITY_FIELDS.UNIVERSITY_NAME
                            ]
                            }`
                          )}
                        </div>
                      ) : null}
                    </div>
                  </div>

                  <div className="fields_label_wrapper">
                    <label className="fields_label mandatory_fields">
                      {t("University Name Arabic")}
                    </label>
                    <Field
                      className="form_inputs"
                      placeholder={t("اسم الجامعة عربي")}
                      name={ADD_UNIVERSITY_FIELDS.UNIVERSITY_NAME_ARABIC}
                      dir='rtl'
                    />
                    <div className="error-message-wrap">
                      {formik.touched[ADD_UNIVERSITY_FIELDS.UNIVERSITY_NAME_ARABIC] &&
                        formik.errors[ADD_UNIVERSITY_FIELDS.UNIVERSITY_NAME_ARABIC] ? (
                        <div className="errorMessage">
                          {t(
                            `${formik.errors[
                            ADD_UNIVERSITY_FIELDS.UNIVERSITY_NAME_ARABIC
                            ]
                            }`
                          )}
                        </div>
                      ) : null}
                    </div>
                  </div>

                  <div className="fields_label_wrappers">
                    <label className="fields_label mandatory_fields">{t("Location")}</label>
                    <div className="address-wrapper">
                      {isLoaded && (
                        <Autocomplete onLoad={onAutocompleteLoad} onPlaceChanged={() => onPlaceChanged(formik)}>
                          <input
                            type="text"
                            className="auto-complete"
                            placeholder="Enter a place"
                            ref={inputRef}
                            name={ADD_UNIVERSITY_FIELDS.LOCATION}
                            value={formik.values[ADD_UNIVERSITY_FIELDS.LOCATION]} 
                            onChange={formik.handleChange}
                          />
                        </Autocomplete>

                      )}
                      {mapEnabled && (
                        <RoomIcon
                          className="room-icon"
                          onClick={() => {
                            setMapEnabled(!mapEnabled);
                          }}
                        />
                      )}
                      {!mapEnabled && (
                        <LocationOffIcon
                          className="room-icon"
                          onClick={() => {
                            setMapEnabled(!mapEnabled);
                          }}
                        />
                      )}
                    </div>
                    {isLoaded && mapEnabled && (
                      <GoogleMap
                        mapContainerClassName="map-container"
                        center={currentLocation}
                        zoom={10}
                      >
                        <MarkerF
                          position={currentLocation}
                          draggable={true}
                          onDragEnd={(e: any) => {
                            setCurrentLatLng(e.latLng.lat(), e.latLng.lng());
                            getFormattedAddress(
                              e.latLng.lat(),
                              e.latLng.lng(),
                              formik, true
                            );
                          }}
                        />
                      </GoogleMap>
                    )}
                    <div className="error-message-wrap">
                      {formik.touched[ADD_UNIVERSITY_FIELDS.LOCATION] &&
                        formik.errors[ADD_UNIVERSITY_FIELDS.LOCATION] ? (
                        <div className="errorMessage">
                          {t(
                            `${formik.errors[ADD_UNIVERSITY_FIELDS.LOCATION]}`
                          )}
                        </div>
                      ) : null}
                    </div>
                  </div>

                  <div className="fields_label_wrapper">
                    <label className="fields_label">
                      {t("Principal's Name")}
                    </label>
                    <Field
                      className="form_inputs"
                      placeholder={t("Principal")}
                      name={ADD_UNIVERSITY_FIELDS.PRINCIPAL}
                      onKeyPress={(event: any) => {
                      }}
                    />
                    <div className="error-message-wrap">
                      {formik.touched[ADD_UNIVERSITY_FIELDS.PRINCIPAL] &&
                        formik.errors[ADD_UNIVERSITY_FIELDS.PRINCIPAL] ? (
                        <div className="errorMessage">
                          {t(
                            `${formik.errors[ADD_UNIVERSITY_FIELDS.PRINCIPAL]}`
                          )}
                        </div>
                      ) : null}
                    </div>
                  </div>

                  <div className="fields_label_wrapper">
                    <label className="fields_label">{t("Total Courses")}</label>
                    <Field
                      className="form_inputs"
                      placeholder={t("Total Courses")}
                      name={ADD_UNIVERSITY_FIELDS.TOTAL_COURSES}
                      onKeyPress={(event: any) => {
                      }}
                    />
                   
                  </div>
                  <div className="fields_label_wrapper">
                    <label className="fields_label">{t("Rating")}</label>
                    <Field
                      className="basic-select-menu"
                      placeholder={"Rating"}
                      onInput={numberOnly}
                      name={ADD_UNIVERSITY_FIELDS.RATING}
                    />

                  </div>
                 
                  <div className="fields_label_wrapper">
                    <label className="fields_label">{t("QS world ranking")}</label>
                    <Field
                      className="basic-select-menu"
                      placeholder={"QS world ranking"}
                      onInput={numberOnly}
                      name={ADD_UNIVERSITY_FIELDS.QS_RANKING}
                      value={formik.values[ADD_UNIVERSITY_FIELDS.QS_RANKING]}
                    />
                    <div className="error-message-wrap"></div>
                   
                  </div>
                  <div className="fields_label_wrapper">
                    <label className="fields_label">{t("The Higher Education Ranking")}</label>
                    <Field
                      className="basic-select-menu"
                      placeholder={"The Higher Education Ranking"}
                      onInput={numberOnly}
                      name={ADD_UNIVERSITY_FIELDS.THE_RANKING}
                    />
                    <div className="error-message-wrap"></div>
                   
                  </div>
                  <div className="fields_label_wrapper">
                    <label className="fields_label">{t("Shanghai Ranking")}</label>
                    <Field
                      className="basic-select-menu"
                      placeholder={"Shanghai Rankings"}
                      onInput={numberOnly}
                      name={ADD_UNIVERSITY_FIELDS.SH_RANKING}
                    />
                    <div className="error-message-wrap"></div>
                   
                  </div>
                  <div className="fields_label_wrapper">
                    <label className="fields_label">
                      {t("Academic Calender")}
                    </label>
                    <div className="grade-pdf-wrapper">
                      <input
                        className="form-input grade-fee-input"
                        value={
                          imageBanner?.split("/")[
                          imageBanner?.split("/").length - 1
                          ]
                        }
                        disabled
                        placeholder="Upload Academic Calender"
                      />
                      <input
                        className="image_input"
                        type="file"
                        accept="application/pdf"
                        onChange={(e: any) => {
                          onUploadEventImage(e, "banner");
                        }}
                        ref={bannerImage}
                      />
                      <div className="upload-icon">
                        {imageBanner && (
                          <VisibilityIcon
                            onClick={() => {
                              window.open(imageBanner, "_blank");
                            }}
                          />
                        )}
                        <FileUploadIcon
                          onClick={() => bannerImage.current?.click()}
                        />
                      </div>
                    </div>
                  </div>

                </div>
              </div>

              {/* ***************************For right for fortion************************ */}
              <div className="col-md-6">
                <div id="card-wrap">
                  <div className="fields_label_wrapper">
                    <label className="fields_label mandatory_fields">{t("Email")}</label>
                    <Field
                      className="form_inputs"
                      name={ADD_UNIVERSITY_FIELDS.EMAIL}
                      placeholder="e.g., name@example.com"
                    />
                    <div className="error-message-wrap">
                      {formik.touched[ADD_UNIVERSITY_FIELDS.EMAIL] &&
                        formik.errors[ADD_UNIVERSITY_FIELDS.EMAIL] ? (
                        <div className="errorMessage">
                          {t(`${formik.errors[ADD_UNIVERSITY_FIELDS.EMAIL]}`)}
                        </div>
                      ) : null}
                    </div>
                  </div>

                  <div className="fields_label_wrapper">
                    <label className="fields_label mandatory_fields">{t("Phone Number")}</label>
                    <PhoneInput
                      inputProps={{
                        className: "",
                        name: `${ADD_UNIVERSITY_FIELDS.PHONE_NUMBER}`,
                      }}
                      country={"ae"}
                      enableSearch={true}
                      countryCodeEditable={true} 
                      value={formik.values[ADD_UNIVERSITY_FIELDS.PHONE_NUMBER]} 
                      onChange={(e) => {
                        formik.setFieldValue(ADD_UNIVERSITY_FIELDS.PHONE_NUMBER, e);

                        setTimeout(() => {
                          formik.validateField(ADD_UNIVERSITY_FIELDS.PHONE_NUMBER);
                          setValidNumber(isValidPhoneNumber(e)); 
                        }, 0);
                      }}
                    />
                    <p className="mb-0 phone-validation">{COMMON_CONSTANTS.PHONE_FORMAT}</p>
                    <div className="error-message-wrap">
                      {validNumber === false &&
                        formik.touched[ADD_UNIVERSITY_FIELDS.PHONE_NUMBER] ? (
                        <div className="errorMessage">
                          {t(
                            EDIT_UNIVERSITY_ERROR_MESSAGE.INVALID_PHONE_NUMBER
                          )}
                        </div>
                      ) : null}
                      {formik.values[ADD_UNIVERSITY_FIELDS.PHONE_NUMBER] ==
                        "" &&
                        validNumber === true &&
                        formik.touched[ADD_UNIVERSITY_FIELDS.PHONE_NUMBER] ? (
                        <div className="errorMessage">
                          {t(
                            EDIT_UNIVERSITY_ERROR_MESSAGE.PHONE_NUMBER_REQUIRED
                          )}
                        </div>
                      ) : null}
                    </div>
                  </div>

                  <div className="fields_label_wrapper">
                    <label className="fields_label mandatory_fields">
                      {t("Weblink of University")}
                    </label>
                    <Field
                      className="form_inputs"
                      placeholder="e.g., https://universityname.com"
                      name={ADD_UNIVERSITY_FIELDS.WEBSITE_ADDRESS}
                    />
                    <div className="error-message-wrap">
                      {formik.touched[ADD_UNIVERSITY_FIELDS.WEBSITE_ADDRESS] &&
                        formik.errors[ADD_UNIVERSITY_FIELDS.WEBSITE_ADDRESS] ? (
                        <div className="errorMessage">
                          {t(
                            `${formik.errors[
                            ADD_UNIVERSITY_FIELDS.WEBSITE_ADDRESS
                            ]
                            }`
                          )}
                        </div>
                      ) : null}
                    </div>
                  </div>
                  <div className="fields_label_wrapper">
                    <label className="fields_label">
                      {t("Number of Students")}
                    </label>
                    <Field
                      className="form_inputs"
                      placeholder={t("Number of Students")}
                      onInput={numberOnly}
                      maxLength={6}
                      name={ADD_UNIVERSITY_FIELDS.NO_OF_STUDENTS}
                    />
                    <div className="error-message-wrap">
                      {formik.touched[ADD_UNIVERSITY_FIELDS.NO_OF_STUDENTS] &&
                        formik.errors[ADD_UNIVERSITY_FIELDS.NO_OF_STUDENTS] ? (
                        <div className="errorMessage">
                          {t(
                            `${formik.errors[
                            ADD_UNIVERSITY_FIELDS.NO_OF_STUDENTS
                            ]
                            }`
                          )}
                        </div>
                      ) : null}
                    </div>
                  </div>
                  <div className="fields_label_wrapper">
                    <label className="fields_label">
                      {t("Global Ranking")}
                    </label>
                    <Field
                      className="form_inputs"
                      placeholder={t("Global Ranking")}
                      onInput={numberOnly}
                      maxLength={6}
                      name={ADD_UNIVERSITY_FIELDS.GLOBAL_RANKING}
                    />
                    <div className="error-message-wrap">
                      {formik.touched[ADD_UNIVERSITY_FIELDS.GLOBAL_RANKING] &&
                        formik.errors[ADD_UNIVERSITY_FIELDS.GLOBAL_RANKING] ? (
                        <div className="errorMessage">
                          {t(
                            `${formik.errors[
                            ADD_UNIVERSITY_FIELDS.GLOBAL_RANKING
                            ]
                            }`
                          )}
                        </div>
                      ) : null}
                    </div>
                  </div>
                  <div className="fields_label_wrapper">
                    <label className="fields_label mandatory_fields">
                      {t("Language of Instruction")}
                    </label>
                    <div className="select-wrapper">
                      <Field
                        as="select"
                        className="form_inputs"
                        placeholder={t(
                          `${ADD_UNIVERSITY_FIELDS.AVAILABLE_MEDIUM}`
                        )}
                        name={ADD_UNIVERSITY_FIELDS.AVAILABLE_MEDIUM}
                      >
                        <option value="">Please select available medium</option>
                        <option value="Arabic">Arabic</option>
                        <option value="English">English</option>
                      </Field>
                    </div>

                    <div className="error-message-wrap">
                      {formik.touched[ADD_UNIVERSITY_FIELDS.AVAILABLE_MEDIUM] &&
                        formik.errors[ADD_UNIVERSITY_FIELDS.AVAILABLE_MEDIUM] ? (
                        <div className="errorMessage">
                          {t(
                            `${formik.errors[
                            ADD_UNIVERSITY_FIELDS.AVAILABLE_MEDIUM
                            ]
                            }`
                          )}
                        </div>
                      ) : null}
                    </div>
                  </div>
                  <div className="fields_label_wrapper">
                    <label className="fields_label">{t("Founded Year")}</label>
                    <LocalizationProvider dateAdapter={AdapterDateFns}>
                      <DatePicker
                        className="date_pickers"
                        label={t("Founded Year")}
                        shouldDisableYear={shouldDisableYear}
                        openTo="year"
                        views={["year"]}
                        value={
                          formik.values[ADD_SCHOOLS.FOUNDED_YEAR] ?
                            new Date(formik.values[ADD_SCHOOLS.FOUNDED_YEAR])
                            : null
                        }
                        onChange={(date) => {
                          const formattedDate = date
                            ? format(date, "yyyy")
                            : "";
                          formik.setFieldValue(
                            ADD_SCHOOLS.FOUNDED_YEAR,
                            formattedDate
                          );
                        }}
                     
                      />
                    </LocalizationProvider>
                    <div className="error-message-wrap">
                      {formik.touched[ADD_SCHOOLS.FOUNDED_YEAR] &&
                        formik.errors[ADD_SCHOOLS.FOUNDED_YEAR] ? (
                        <div className="errorMessage">
                          {t(`${formik.errors[ADD_SCHOOLS.FOUNDED_YEAR]}`)}
                        </div>
                      ) : null}
                    </div>
                  </div>

                  <div className="fields_label_wrapper">
                    <label className="form-label mandatory_fields">{t("Country")}</label>
                    <Field
                      name={ADD_UNIVERSITY_FIELDS.COUNTRY}
                      value={formik.values[ADD_UNIVERSITY_FIELDS.COUNTRY]}
                      onBlur={formik.handleBlur}
                      placeholder={"Country"}
                      className="basic-select-menu"
                      disabled
                    />


                    <div className="error-message-wrap">
                      {formik.touched[ADD_UNIVERSITY_FIELDS.CITY] &&
                        formik.errors[ADD_UNIVERSITY_FIELDS.CITY] ? (
                        <div className="errorMessage">
                          {t(`${formik.errors[ADD_UNIVERSITY_FIELDS.CITY]}`)}
                        </div>
                      ) : null}
                    </div>
                  </div>


                  <div className="fields_label_wrapper">
                    <label className="form-label">{t("States/Emirates")}</label>
                    <div className="select-wrapper">
                      <Field
                        as="select"
                        name={ADD_UNIVERSITY_FIELDS.EMIRATES}
                        value={formik.values[ADD_UNIVERSITY_FIELDS.EMIRATES]}
                        onBlur={formik.handleBlur}
                        className="basic-select-menu"
                        onChange={(e: any) => {
                          formik.setFieldValue(ADD_UNIVERSITY_FIELDS.EMIRATES, e.target.value)
                        }}
                      >
                        <option value={" "}>{"Please select the emirate"}</option>
                        {formik.values[ADD_UNIVERSITY_FIELDS.COUNTRY] === 'United Arab Emirates' && EmiratesList?.map((item: any) => {
                          return (
                            <option value={item.emirate_city}>{item.emirate_city}</option>
                          )
                        })}
                      </Field>
                    </div>


                    <div className="error-message-wrap">
                      {formik.touched[ADD_UNIVERSITY_FIELDS.EMIRATES] &&
                        formik.errors[ADD_UNIVERSITY_FIELDS.EMIRATES] ? (
                        <div className="errorMessage">
                          {t(`${formik.errors[ADD_UNIVERSITY_FIELDS.EMIRATES]}`)}
                        </div>
                      ) : null}
                    </div>
                  </div>
                  <div className="fields_label_wrapper">
                    <label className="form-label">{t("City")}</label>
                    <div className="select-wrapper">
                      <Field
                        as="select"
                        name={ADD_UNIVERSITY_FIELDS.CITY}
                        value={formik.values[ADD_UNIVERSITY_FIELDS.CITY]}
                        onBlur={formik.handleBlur}
                        className="basic-select-menu"
                        onChange={(e: any) => {
                          formik.setFieldValue(ADD_UNIVERSITY_FIELDS.CITY, e.target.value)
                        }}
                      >
                        <option value={" "}>{"Please select the city"}</option>
                        {formik.values[ADD_UNIVERSITY_FIELDS.COUNTRY] === 'United Arab Emirates' && EmiratesList?.map((item: any) => {
                          return (
                            <option value={item.emirate_city}>{item.emirate_city}</option>
                          )
                        })}
                      </Field>
                    </div>


                    <div className="error-message-wrap">
                      {formik.touched[ADD_UNIVERSITY_FIELDS.CITY] &&
                        formik.errors[ADD_UNIVERSITY_FIELDS.CITY] ? (
                        <div className="errorMessage">
                          {t(`${formik.errors[ADD_UNIVERSITY_FIELDS.CITY]}`)}
                        </div>
                      ) : null}
                    </div>
                  </div>

                </div>
              </div>
              <div className="fields_label_wrapper mt-3" id="desc-card-wrap">
                <label className="fields_label mandatory_fields">{t("Description")}</label>
                <Field
                  className="description-testarea"
                  placeholder="Enter Description"
                  as="textarea"
                  name={ADD_UNIVERSITY_FIELDS.DESCRIPTION}
                  rows={4}
                  onKeyPress={(event: any) => {
                    if (250 - formik.values.description.length <= 0)
                      event?.preventDefault();
                  }}
                  onPaste={(event: any) => {
                    const updatedValue =
                      formik.values.description +
                      event.clipboardData.getData("text");
                    if (updatedValue.length > 250) {
                      event.preventDefault();
                    }
                  }}
                ></Field>
                <p className="characters-left">
                  {250 - formik.values.description?.length}{" "}
                  {t("characters left")}
                </p>
                <div className="error-message-wrap">
                  {formik.touched[ADD_UNIVERSITY_FIELDS.DESCRIPTION] &&
                    formik.errors[ADD_UNIVERSITY_FIELDS.DESCRIPTION] ? (
                    <div className="errorMessage">
                      {t(`${formik.errors[ADD_UNIVERSITY_FIELDS.DESCRIPTION]}`)}
                    </div>
                  ) : null}
                </div>
              </div>
            </div>

            <div className="row school-row-wrap">
              <div id="card-title">{t("Application Process")}</div>
              <div className="col-md-12">
                <div id="card-wrap">
                  <div className="application-btn-wrapper">
                    <input
                      className="form_inputs"
                      placeholder={t(
                        "Please add application process as points"
                      )}
                      onChange={(e: any) => {
                        setAppProcessPoints(e.target.value);
                      }}
                      value={appProcessPoints}
                      maxLength={750}
                    />
                    <button
                      type="button"
                      className="btn add-btn"
                      onClick={() => {
                        if (nullUndefinedEmptyCheck(appProcessPoints)) {
                          let data: any = applicationProcess;
                          data.push(appProcessPoints);
                          setApplicationProcess([...data]);
                          setAppProcessPoints("");
                        }
                      }}
                    >
                      Add
                    </button>
                  </div>
                  {applicationProcess?.length > 0 && (
                    <div className="event-wrap">
                      <List>
                        {applicationProcess?.map((point: any, index: any) => {
                          return (
                            <div>
                              <ListItemButton className="list-btn" key={index}>
                                <ListItemText primary={point} />
                                <DeleteIcon
                                  onClick={() => {
                                    let data: any = applicationProcess;
                                    data.splice(index, 1);
                                    setApplicationProcess([...data]);
                                  }}
                                />
                              </ListItemButton>
                            </div>
                          );
                        })}
                      </List>
                    </div>
                  )}
               
                </div>
              </div>
            </div>
            <div className="row school-row-wrap">
              <div id="card-title">{t("Eligibility Criteria")}</div>
              <div className="col-md-12">
                <div id="card-wrap">
                  <div className="application-btn-wrapper">
                    <input
                      className="form_inputs"
                      placeholder={t(
                        "Please add eligibility criteria as points"
                      )}
                      onChange={(e: any) => {
                        setEligibilityPoints(e.target.value);
                      }}
                      value={eligibilityPoints}
                      maxLength={750}
                    />
                    <button
                      type="button"
                      className="btn add-btn"
                      onClick={() => {
                        if (nullUndefinedEmptyCheck(eligibilityPoints)) {
                          let data: any = eligibilityCriteria;
                          data.push(eligibilityPoints);
                          setEligibilityCriteria([...data]);
                          setEligibilityPoints("");
                        }
                      }}
                    >
                      Add
                    </button>
                  </div>
                  {eligibilityCriteria?.length > 0 && (
                    <div className="event-wrap">
                      <List>
                        {eligibilityCriteria?.map((point: any, index: any) => {
                          return (
                            <div>
                              <ListItemButton className="list-btn" key={index}>
                                <ListItemText primary={point} />
                                <DeleteIcon
                                  onClick={() => {
                                    let data: any = eligibilityCriteria;
                                    data.splice(index, 1);
                                    setEligibilityCriteria([...data]);
                                  }}
                                />
                              </ListItemButton>
                            </div>
                          );
                        })}
                      </List>
                    </div>
                  )}
                 
                </div>
              </div>
            </div>

            <div className="row school-row-wrap">
              <div id="card-title" className="mandatory_fields">{t("Programs Offered")}</div>
              <div className="programs-options-wrapper">
                <Select
                  className="select-menu grade-fee-input"
                  defaultValue={" "}
                  value={programType}
                  onChange={(e: any) => {
                    setProgramType(e.target.value);
                    let data: any = degreeType.filter((res: any, i: any) => {
                      return res.id == e.target.value;
                    });
                    setProgramOffered(data[0].programs_offered);
                  }}
                >
                  <MenuItem value=" ">Select degree type</MenuItem>
                  {degreeType?.map((degree: any, i: any) => {
                    return (
                      <MenuItem value={degree.id}>
                        {degree.programs_offered}
                      </MenuItem>
                    );
                  })}
                </Select>
                <Select
                  className="select-menu grade-fee-input"
                  defaultValue={" "}
                  value={classificationType}
                  onChange={(e: any) => {
                    setClassificationType(e.target.value);
                    let data: any = fieldType.filter((res: any, i: any) => {
                      return res.id == e.target.value;
                    });
                    setProgramName(data[0].programs_name);
                  }}
                >
                  <MenuItem value=" ">Select field of study</MenuItem>
                  {fieldType?.map((degree: any, i: any) => {
                    return (
                      <MenuItem value={degree.id}>
                        {degree.programs_name}
                      </MenuItem>
                    );
                  })}
                </Select>
                <MuiAutocomplete
                  className="select-menu grade-fee-input specification-type"
                  disableClearable
                  options={specification}
                  getOptionLabel={(option:any) => option.sub_program_name}
                  onChange={(event, newValue) => {setSubprogramName(newValue.sub_program_name); setCourseName(newValue.id)}}
                  renderInput={(params) => <TextField {...params} placeholder="Select specification type" 
                  InputLabelProps={{ shrink: false }}  
                  />}
                />
                <input
                  placeholder="Fee in AED"
                  value={courseFee}
                  maxLength={6}
                  onInput={numberOnly}
                  onChange={(e: any) => {
                    setCourseFee(e.target.value);
                  }}
                />
                <button className="btn btn-primary" onClick={onAddProgram}>
                  Add
                </button>
              </div>

              {programsOffered.length > 0 && (
                <div className="event-wrap">
                  <table>
                    <tr>
                      <th>Program Type</th>
                      <th>Course Domain</th>
                      <th>Course Name</th>
                      <th>Course Fee</th>
                      <th>Action</th>
                    </tr>
                  </table>
                  <table>
                    {programsOffered.map((grade: any, i: any) => {
                      return (
                        <>
                          <tr>
                            <td>{grade.university_program_name}</td>
                            <td>{grade.program_class_name}</td>
                            <td>{grade.sub_program_class_name}</td>
                            <td>{grade.price}</td>
                            <td>
                              <DeleteIcon
                                onClick={() => {
                                  let data = programsOffered;
                                  data.splice(i, 1);
                                  setProgrammsOffered([...data]);
                                }}
                              />
                            </td>
                          </tr>
                        </>
                      );
                    })}
                  </table>
                </div>
              )}
              <div className="error-message-wrap mt-2">
                {programsOffered.length === 0 && formSubmitted ? (
                  <div className="errorMessage">
                    {t(`${EDIT_UNIVERSITY_ERROR_MESSAGE.PROGRAMS_OFFERED}`)}
                  </div>
                ) : null}
              </div>
            </div>

            <div className="row school-row-wrap">
              <div className="col-md-12">
                <div className="fields_label_wrapper">
               
                  <input
                    className="image_input"
                    type="file"
                    accept="image/png,image/jpg,image/jpeg,image/svg"
                    multiple
                    onChange={handleChange}
                    ref={uploadUniversityImages}
                  />
                  <div className="add_images_wrapper">
                    <div
                      className="add_images_cotainer"
                      onClick={() => uploadUniversityImages.current?.click()}
                    >
                      <img src={upload_image} alt="Learn and Play" />
                      <div>{t("Add Image")}</div>
                    </div>
                    <div className="text_contant">
                      Recommended size: 780x586 with JPEG,PNG
                    </div>
                  </div>
                  <div className="error-message-wrap">
                    {formik.touched[ADD_UNIVERSITY_FIELDS.UNIVERSITY_IMAGES] &&
                      formik.errors[ADD_UNIVERSITY_FIELDS.UNIVERSITY_IMAGES] ? (
                      <div className="errorMessage">
                        {t(
                          `${formik.errors[
                          ADD_UNIVERSITY_FIELDS.UNIVERSITY_IMAGES
                          ]
                          }`
                        )}
                      </div>
                    ) : null}
                  </div>
                </div>
                <div className="image-array-wrap">
                  {universityImages.map((image: any, index: any) => {
                    return (
                      <div className="image-wrap" key={index}>
                        <img
                          src={image}
                          key={index}
                          className="schoolimage-list"
                          alt="Learn and Play"
                        />
                        <img
                          className="cancel-icon"
                          onClick={handleDelete(index)}
                          src={close}
                          alt="Learn and Play"
                        />
                      </div>
                    );
                  })}
                </div>
              </div>
            </div>
            <div className="actions_button_container">
              <button
                className="cancel_button"
                onClick={() => {
                  navigate("/manage-universities");
                }}
              >
                {t("Cancel")}
              </button>
              <button
                className="update_button"
                type="submit"
                onClick={() => {
                  formik.handleSubmit();
                  setFormSubmitted(true);
                }}
              >
                {id ? t("Update") : t("Submit")}
              </button>
            </div>
          </div>
        )}
      </Formik>
    </>
  );
};

export default AddEditUniversity;
